import { mapVenueDetailsType, useFindVenueSuspense } from '@api';
import { NavigateBackButton } from '@common';
import { Group } from '@mantine/core';
import { Route } from 'src/routes/_rootLayout/venues/$id';

export const VenueDetailsHeader: React.FC = () => {
  const { id } = Route.useParams();
  const { data: venue } = useFindVenueSuspense(id, {
    query: { select: (data) => mapVenueDetailsType(data.data) },
  });

  return (
    <Group gap="xs">
      <NavigateBackButton to="/venues" />
      {venue.name}
    </Group>
  );
};
